import React from 'react'
import GModal from '../../shared/gModal'
import CustomValuesHook from '../../functions/myHooks/CustomValuesHook'
import { Col, FormControl, FormLabel, Row } from 'react-bootstrap'
import { display } from '@mui/system'
import { addHolidays, deleteHolidays, updateHolidays } from '../../api/requestAxios/calendarHolidayRequests'
import moment from 'moment-jalaali'
import { HolyDayType } from '../../types/holiday/types'
import { ErrorToast, InfoToast } from '../../shared'
import { getDateOfTimeZoneDate, getEnDate } from '../../shared/helper'
import { enToPersianChar } from '../activities'

const ActionMenu = ({ day, holidays, getHolidays, clearMenu }: { day: any, holidays: any[], getHolidays: Function, clearMenu: Function }) => {
    const [states, setStates] = CustomValuesHook({ displayModal: false, title: '', selectedDayToUpdate: undefined })


    const handleInsert = async () => {
        setStates({ pending: true })
        const params: HolyDayType = {
            title: states.title,
            date: getEnDate(day.dateStr),
            id: undefined
        }
        try {
            const response = await addHolidays([params])

            setStates({ pending: false })
            setStates({ displayModal: false, selectedDayToAdd: undefined })
            InfoToast('عملیات با موفقیت انجام شد')
            clearMenu()
            getHolidays()
        } catch (error) {
            setStates({ pending: false })
            ErrorToast('بروز خطا در عملیات')

        }
    }

    const handleUpdateHoliday = async () => {
        setStates({ pending: true })
        const params: HolyDayType = {
            title: states.selectedDayToUpdate.title,
            date: states.selectedDayToUpdate.date,
            id: states.selectedDayToUpdate.id
        }
        try {
            const response = await updateHolidays([params])

            setStates({ pending: false })
            setStates({ displayModal: false, selectedDayToUpdate: undefined })
            InfoToast('عملیات با موفقیت انجام شد')
            clearMenu()

            getHolidays()
        } catch (error) {
            setStates({ pending: false })
            ErrorToast('بروز خطا در عملیات')

        }
    }
    const handleUpdate = () => {

        const _day = holidays.find((i: any) => getDateOfTimeZoneDate(i.date) === getEnDate(day.dateStr))
        setStates({ selectedDayToUpdate: _day, displayModal: true })
    }
    const bodyComponent = () => {
        return (<div>
            <form onSubmit={states.selectedDayToUpdate ? handleUpdate : handleInsert}>
                <Row>
                    <Col lg={12} xs={12} className='p-4'>
                        <div>
                            <h6>
                                <b>{day.name} {enToPersianChar(day.day)} {day.monthName}</b>
                            </h6>
                        </div>
                        <FormLabel htmlFor="nameInput">عنوان
                            <span className="required"> * </span>
                        </FormLabel>
                        <div className='position-relative'>
                            <FormControl
                                value={states.selectedDayToUpdate ? states.selectedDayToUpdate.title : states.title}
                                onChange={(e) => {
                                    if (states.selectedDayToUpdate) {
                                        setStates({ selectedDayToUpdate: { ...states.selectedDayToUpdate, title: e.target.value } })
                                    } else {
                                        setStates({ title: e.target.value })
                                    }
                                }
                                }

                                type="text"
                                id="nameInput"
                                required
                            />
                        </div>
                    </Col>

                </Row>
            </form>
        </div>)
    }
    const handleSelectDay = () => {

        setStates({ selectedDayToAdd: day, displayModal: true })
    }

    const handleDeleteDayHoliday = () => {

        const _day = holidays.find((i: any) => getDateOfTimeZoneDate(i.date) === getEnDate(day.dateStr))
        setStates({ selectedDayToDelete: _day, displayDeleteModal: true })
    }
    const titleComponent = () => {
        return (<div style={{ fontSize: '14px' }}>اضافه کردن روز تعطیل</div>)
    }
    const handleDelete = async () => {
        setStates({ pending: true })

        try {
            const response = await deleteHolidays([states.selectedDayToDelete.id])

            setStates({ pending: false })
            setStates({ displayDeleteModal: false, selectedDayToDelete: undefined })
            InfoToast('عملیات با موفقیت انجام شد')
            clearMenu()
            getHolidays()
        } catch (error) {
            setStates({ pending: false })
            ErrorToast('بروز خطا در عملیات')

        }
    }

    const footerComponent = () => {

        return (<div className='d-flex justify-content-end'>
            <button className='btn btn-default mx-2'
                onClick={() => setStates({ displayModal: false, selectedDayToUpdate: undefined, selectedDayToAdd: undefined })} >انصراف</button>
            <button className='btn btn-primary' disabled={(!states.selectedDayToUpdate && !states.title) || (states.selectedDayToUpdate && !states.selectedDayToUpdate.title)
                || states.pending || states.updatePending}
                onClick={states.selectedDayToUpdate ? handleUpdateHoliday : handleInsert}>ثبت</button>
        </div>)
    }

    const deleteFooterComponent = () => {

        return (<div className='d-flex justify-content-end'>
            <button className='btn btn-default mx-2'
                onClick={() => setStates({ displayDeleteModal: false, selectedDayToDelete: undefined })} >انصراف</button>
            <button className='btn btn-primary' disabled={states.pending}
                onClick={handleDelete}>تایید</button>
        </div>)
    }

    return (
        <>
            <ul>
                {!holidays.some((i: any) => getDateOfTimeZoneDate(i.date) === getEnDate(day.dateStr)) && <li onClick={handleSelectDay}><span>اضافه کردن روز تعطیل</span></li>}
                {holidays.some((i: any) => getDateOfTimeZoneDate(i.date) === getEnDate(day.dateStr)) && <>
                    <li onClick={handleUpdate}><span>ویرایش توضیحات</span></li>
                    <li onClick={handleDeleteDayHoliday}><span>حذف</span></li>
                </>}


            </ul>
            <GModal
                show={states.displayModal}
                setShow={() => setStates({ displayModal: false, selectedDayToUpdate: undefined, selectedDayToAdd: undefined })}
                title={titleComponent}
                description={''}
                component={bodyComponent}
                classNames={''}
                size={'lg'}
                confirmButtonText={''}
                cancelButtonText={''}
                confirmAction={function (event: React.MouseEvent<HTMLElement, MouseEvent>): void {
                    throw new Error('Function not implemented.')
                }}
                footerComponent={footerComponent} backdrop={false} />

            <GModal
                show={states.displayDeleteModal}
                setShow={() => setStates({ displayDeleteModal: false, selectedDayToDelete: undefined })}
                title={() => <div>تایید حذف</div>}
                description={''}
                component={() => <div>
                    <div></div>
                    آیا از عملیات حذف
                    روز تعطیل<b> &nbsp;{day.name} {enToPersianChar(day.day)} {day.monthName} &nbsp;</b>
                    اطمینان دارید؟</div>}
                classNames={''}
                size={"sm"}
                confirmButtonText={''}
                cancelButtonText={''}
                confirmAction={function (event: React.MouseEvent<HTMLElement, MouseEvent>): void {
                    throw new Error('Function not implemented.')
                }}
                footerComponent={deleteFooterComponent} backdrop={false} />
        </>
    )
}

export default ActionMenu